export const MISSING_USERNAME = 'Username is required'
export const MISSING_FIRST_NAME = 'First name is required'
export const MISSING_LAST_NAME = 'Last name is required'
export const INVALID_EMAIL = 'Oops, that email is invalid'
export const EMAIL_ALREADY_TAKEN = 'Email already exists'
